import { isValidPhoneNumber } from 'libphonenumber-js';
import * as yup from 'yup';
import { ObjectSchema } from 'yup';
import { RequiredBooleanSchema } from 'yup/lib/boolean';
import StringSchema, { RequiredStringSchema } from 'yup/lib/string';
import { Maybe } from 'yup/lib/types';

type ValidationSchemaArg = {
  email: RequiredStringSchema<Maybe<string>>;
  firstName: RequiredStringSchema<Maybe<string>>;
  lastName: RequiredStringSchema<Maybe<string>>;
  phoneNumber: StringSchema; // Loosen type to allow optional phone number depending on a form
  termsOfService: RequiredBooleanSchema<Maybe<boolean>>;
};

export type ValidationSchema = ObjectSchema<ValidationSchemaArg>;

export const phoneNumberSchema = yup.string().test({
  name: 'is-phone-number',
  message: { id: 'validation.enterValidPhoneNumber' },
  test: (v: string | undefined) => !v || isValidPhoneNumber(v),
});

export const termsOfServiceSchema = yup.boolean().test({
  name: 'is-checked',
  test: (checked: boolean) => checked,
});

export const merchantSignUpFormValidationSchema: ValidationSchema = yup.object({
  email: yup.string().required(),
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  phoneNumber: phoneNumberSchema.required(),
  termsOfService: termsOfServiceSchema.required(),
});
